var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-recruit-form-shared"},[(_vm.loading)?_c('LoadingSpinner'):_vm._e(),_c('AppForm',{attrs:{"structures":_vm.sharedInfoStructure,"model":_vm.formData.data,"errors":_vm.showError?_vm.formDataErrors:[]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }